import(/* webpackMode: "eager" */ "/home/runner/work/examanet/examanet/src/app/[locale]/newdesign2027/NewDesign2027Client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/examanet/examanet/src/components/resources/ResourceDetailClient.tsx");
